import "./ProgressBar.css";

export default function ProgressBar({
  length = 5,
  index = 1,
  status = false,
  colorLastStep = true,
}) {
  return (
    <div className="ProgressBar">
      <span className="ProgressBar-numerical">
        {`${status ? index : index + 1}/${length}`}
      </span>
      <div className="ProgressBar-wrapper">
        <div
          className="ProgressBar-wrapper-progress"
          style={{
            width: `${((status ? index : index + 1) * 100) / length}%`,
            backgroundColor:
              (status && index === length) ||
              (!status && index + 1 === length && colorLastStep)
                ? "var(--color-success-1)"
                : "var(--color-leano-2)",
          }}
        ></div>
      </div>
    </div>
  );
}
